import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const InvoiceSchema = withDefaults({
  type: 'invoice',
  objectExtensions: ['invoice'],
  fields: [
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'invoiceType',
    },
    {
      kind: 'attribute',
      name: 'stats',
    },
    {
      kind: 'attribute',
      name: 'invoiceDate',
    },
    {
      kind: 'attribute',
      name: 'status',
    },
    {
      kind: 'attribute',
      name: 'purchaseOrderNumber',
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'invoiceLineItems',
      type: 'invoice-line-item',
      options: {
        async: false,
        inverse: 'invoice',
      },
    },
  ],
});

export default InvoiceSchema;
